import { Button } from 'components/atoms';
import LabeledStatementConsistancy from 'components/molecules/labeledStatus/LabeledStatementConsistancy';
import LabeledStatementStatus from 'components/molecules/labeledStatus/LabeledStatementStatus';
import { Form } from 'components/organisms';
import { initialStatement } from 'components/organisms/forms/statements/ExchangeRatesForm';
import { PiDownload } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { useGetStatementDetail } from 'services/statements';
import { STATEMENT_CONSISTANCY } from 'services/statements/types';
import { handleDownloadFile } from 'utils/global/linkToUrl.utils';

const Statement = () => {
  const i18nextPrefix = 'statements';
  const { id = '', accountId = '' } = useParams();

  const { data, isLoading } = useGetStatementDetail(id, accountId);

  const formValues = data
    ? {
        ...data,
        defaultTotalValue: parseFloat(
          (data.defaultTotalValue ?? 0).toFixed(2)
        ),
      }
    : initialStatement;

  return (
    <Form.Statements
      i18nextPrefix={i18nextPrefix}
      backPath='/statements'
      initialValues={formValues}
      topbarContent={
        data && (
          <>
            {data.consistency?.id != null && (
              <LabeledStatementConsistancy
                status={data.consistency.id as STATEMENT_CONSISTANCY}
              />
            )}
            <LabeledStatementStatus status={data.statementStatus} />
            <div className='flex'>
              <Button
                onlyIcon
                isClear
                disabled={!data.statementFilePath}
                onClick={() =>
                  data.statementFilePath &&
                  handleDownloadFile(data.statementFilePath)
                }>
                <Button.Icon icon={<PiDownload />} />
              </Button>
            </div>
          </>
        )
      }
      onSubmit={() => {}}
      tittle={data?.salesChannelName}
      status={{ displayMode: true, isLoading }}
    />
  );
};

export default Statement;
